import React from 'react';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';

export default function AdditionalPPCSlider(props) {
  const settings = {
    infinite: false,
    speed: 400,
    slidesToShow: 3,
    autoplay: false,
    arrows: false,
    dots: false,
    swipe: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          swipe: true,
          dots: true,
          centerMode: true,
          centerPadding: '15px',
          dotsClass: 'custom-dots',
        },
      },
    ],
    afterChange: function (a, b) {},
  };

  return (
    <div id="slider_reviews_2">
      <style jsx global>{`
        .custom-dots {
          display: flex !important;
          justify-content: center;
          margin-top: 30px;
        }
        .custom-dots li {
          position: relative;
          margin: 0 3px;
          width: 50px;
          height: 3px;
          background-color: #c4c4c4;
          overflow: hidden;
        }
        .custom-dots li.slick-active {
          background-color: #670f7a;
        }
        .custom-dots li button {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          opacity: 0;
          //display:none;
        }
      `}</style>
      <Slider {...settings} className="process-slider relative z-10">
        <a className={`w-full  p-20 pl-0 `} href="/main/digital-ad-banners">
          <img
            className="w-full"
            src="https://admin.weprodigi.com/uploads/files/shares/ppc/social_media_advertising3.png"
            alt="social_media_advertising3"
          />
          <p className="mt-15 flex">
            <img width={15} src="https://admin.weprodigi.com/uploads/files/shares/ppc/play.svg" alt="play" />
            <span className="ml-15">Social Media Advertising</span>
          </p>
        </a>
        <a className={`w-full p-20 pl-0`} href={'/social-media-marketing'}>
          <img
            className="w-full"
            src="https://admin.weprodigi.com/uploads/files/shares/ppc/social_media_marketing1.png"
            alt="social_media_marketing1"
          />
          <p className="mt-15 flex">
            <img width={15} src="https://admin.weprodigi.com/uploads/files/shares/ppc/play.svg" alt="play" />
            <span className="ml-15">Social Media Marketing</span>
          </p>
        </a>
        <a className={`w-full p-20 pl-0`} href={'/main/digital-ad-banners'}>
          <img className="w-full" src="https://admin.weprodigi.com/uploads/files/shares/ppc/banner_advertising1.png" alt="banner_advertising1" />
          <p className="mt-15 flex">
            <img width={15} src="https://admin.weprodigi.com/uploads/files/shares/ppc/play.svg" alt="play" />
            <span className="ml-15">Banner Production</span>
          </p>
        </a>
      </Slider>
    </div>
  );
}
